export default __webpack_public_path__ + "static/media/download.e60f5bb5.svg";